export const compareFooterPosition = (a, b) => a.footerPosition - b.footerPosition;
